import React, { useCallback } from 'react';
import { PageSection, pdpSectionStyle } from 'common/components/page-section';
import { Characteristic, getCharacteristics, isProductSet } from 'features/product-info';
import { useSelector } from 'react-redux';
import { analyticsUtils, jc } from 'utils';
import { getSectionMeta } from 'features/page-navigation/ducks/selectors';
import { Context } from 'features/page-navigation/components/section-refs-context';
import { List, ListItem } from './list';
import { SectionHeader } from 'common/components';
import { getCharacteristicLinks } from 'features/linked-pages';

export const DATA_QA_PDP_C14S_SECTION = 'pdp-c14s-section';

type Props = React.HTMLAttributes<HTMLElement> & {
  onCollapsedToggle: (cancelAnimations?: boolean) => void;
};

const getC14sSectionMeta = getSectionMeta('c14s');

export const Characteristics: React.FC<Props> = ({ id, className, onCollapsedToggle }) => {
  const sectionMeta = useSelector(getC14sSectionMeta);
  const characteristics = useSelector(getCharacteristics);
  const isSet = useSelector(isProductSet);
  const characteristicLinks = useSelector(getCharacteristicLinks);

  const ref = React.useContext(Context).get('characteristics');

  const sendAnalytics = useCallback((isFade: boolean) => {
    analyticsUtils.sendEvent('GA:clickButton', {
      elementBlock: isSet ? 'komplektyDetail' : 'productDetail',
      elementName: `characteristics / ${isFade ? 'close' : 'open'}`,
      elementText: 'Характеристики',
      elementType: 'button',
    });
  }, []);

  if (sectionMeta) {
    return (
      <section
        id={id || sectionMeta.navigationId}
        className={jc(pdpSectionStyle, className || '')}
        data-qa={DATA_QA_PDP_C14S_SECTION}
      >
        <PageSection
          onSendAnalytics={sendAnalytics}
          sectionLocation="c14s"
          variant="v-limited"
          onCollapsedToggle={onCollapsedToggle}
          headline={<SectionHeader ref={ref}>{sectionMeta.title}</SectionHeader>}
        >
          <List>
            {characteristics?.map(({ key, value, description }: Characteristic) => (
              <ListItem
                key={key}
                attribute={key}
                value={value}
                description={description}
                href={characteristicLinks?.[key] || undefined}
              />
            ))}
          </List>
        </PageSection>
      </section>
    );
  }
  return null;
};
